import Cookie from 'js-cookie'

/**
 * Set a cookie on the client side
 * @param name Cookie name
 * @param value Cookie value
 * @param options Cookie options (expires, path, domain, secure, sameSite)
 */
export const setClientCookie = (
  name: string,
  value: string,
  options?: {
    expires?: number | Date
    path?: string
    domain?: string
    secure?: boolean
    sameSite?: 'strict' | 'lax' | 'none'
  }
) => {
  if (typeof window === 'undefined') {
    return // Only run on client side
  }

  const cookieOptions: Cookie.CookieAttributes = {
    expires: options?.expires, // Default to 7 days
    path: options?.path || '/',
    secure: options?.secure ?? process.env.NODE_ENV !== 'development',
    sameSite: options?.sameSite || 'lax',
  }

  if (options?.domain) {
    cookieOptions.domain = options.domain
  }

  try {
    Cookie.set(name, value, cookieOptions)

    // Verify the cookie was actually set
    const allCookies = document.cookie

    // Check if our specific cookie is in the string
    if (!allCookies.includes(`${name}=`)) {
      const fallbackOptions = {
        expires: options?.expires,
        path: options?.path || '/',
        secure: options?.secure ?? process.env.NODE_ENV !== 'development',
        sameSite:
          process.env.NODE_ENV === 'development'
            ? 'lax'
            : options?.sameSite || 'lax',
      }

      let cookieString = `${name}=${value}`
      if (fallbackOptions.expires) {
        const date = new Date()
        const expiresDays =
          typeof fallbackOptions.expires === 'number'
            ? fallbackOptions.expires
            : 7
        date.setTime(date.getTime() + expiresDays * 24 * 60 * 60 * 1000)
        cookieString += `; expires=${date.toUTCString()}`
      }
      cookieString += `; path=${fallbackOptions.path}`

      if (fallbackOptions.secure) {
        cookieString += '; secure'
      }

      if (fallbackOptions.sameSite) {
        cookieString += `; samesite=${fallbackOptions.sameSite}`
      }

      document.cookie = cookieString
    }
  } catch (error) {
    console.error(`Error setting cookie ${name}:`, error)
  }
}
